<template>
  <div 
    class="  px-3 mt-8">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold">
            Tambahkan Invoice Customer
          </div>

          <v-row
            class="">
            <v-col 
              cols="12"
              class="px-0 pt-0">
              <v-card 
                flat
                style="background: transparent;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Mitra Warung" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>

                        <v-col
                          cols="12"
                          md="12" class="pt-0">

                          <!-- <ValidationProvider
                            name="No Order" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              No BPB
                            </div> -->
      
                            <!-- <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="No BPB"
                              v-on:change="changeOrder()"
                              
      
                              
                              :items="order"
                              item-value="id"
                              item-text="number"
                              :item-color="set_color"
                              spellcheck="false" 
                              :filter="customFilter"
      
                              v-model="form.bpb_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">

                              <template v-slot:selection="{ item }">
                                <div
                                  v-if="item" style="color: #718EBF">
                                  {{ item.number }} ({{ item.customer_name }})
                                </div>
                              </template>
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title>{{ item.number }}</v-list-item-title>
                                  <v-list-item-subtitle>{{ item.customer_name }}</v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </v-autocomplete> -->
                            
                          <!-- </ValidationProvider> -->

                          <v-card flat>
                            
                            <v-card-text>
                              <div 
                                class="fs-15 label-input">
                                No BPB
                              </div>

                              <v-text-field
                                @click:clear="search = ''; fetchOrder();"
                                v-on:keydown.enter.prevent="fetchOrder()"

                                filled
                                rounded
                                dense
                                single-line

                                hide-details
                                :color="set_color"
                                placeholder="Cari data yang Anda butuhkan . . ."
                                append-icon="mdi-magnify"
                                clearable

                                v-model="search"
                                class="mb-5 fs-12 little-placeholder"
                                style="border-radius: 6px; background: #d9e8ff9c !important;">
                              </v-text-field>
                              <div v-if="!process.load" style="overflow: auto; background: #fff; border-radius: 6px; border: 1px solid #E7E7E7;" :style="order.length > 0 ? 'height: 400px;' : ''">
                                <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                  <tr>
                                    <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                      Aksi
                                    </th>
                                    <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      No BPB
                                    </th>
                                    <!-- <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      No Sales Order
                                    </th>
                                    <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      Tgl Order
                                    </th> -->
                                    <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      Nama Toko
                                    </th>
                                    <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      Nama Customer
                                    </th>
                                    <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      Alamat
                                    </th>
                                    <th style="position: sticky; top: 0; background-color: white !important; font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      Nama Sales
                                    </th>
                                  </tr>
                                  <tr v-for="(item, index) in order" :key="index">
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 100px; min-width: 100px; max-width: 100px;" class="black--text">
                                      <v-btn
                                        @click="form.bpb_id = item.id; changeOrder()"
                                        small
                                        class="white--text text-capitalize"
                                        :color="form.bpb_id === item.id ? '#127800' : '#4c99ff'"
                                        elevation="0">
                                        {{ form.bpb_id === item.id ? 'Terpilih' : 'Pilih' }}
                                      </v-btn>
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.number }}
                                    </td>
                                    <!-- <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.order_number }}
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.order_input_datetime | datetime }}
                                    </td> -->
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.store_name }}
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.customer_name }}
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left;" class="black--text">
                                      {{ item.customer_shipping_province }}, {{ item.customer_shipping_city }}, {{ item.customer_shipping_subdistrict }}, {{ item.customer_shipping_village }}
                                    </td>
                                    <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                      {{ item.sales_name }}
                                    </td>
                                  </tr>
                                </table>
                              </div>
                            </v-card-text>

                            <v-card-text
                              v-if="process.load" 
                              class="pb-0 my-4" 
                              style="height: 300px; display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <div class="mb-4 title">
                                  Mohon Tunggu . . .
                                </div>
  
                                <v-progress-linear
                                  :color="set_color"
                                  indeterminate
                                  rounded
                                  height="10">
                                </v-progress-linear>
                              </div>
                            </v-card-text>
  
                            <v-card-text
                              v-if="!process.load && order.length === 0"
                              class="pb-0 my-4" style="height: 300px; display: flex; align-items: center; justify-content: center;">
                              <div class="text-center">
                                <v-img 
                                  class="mx-auto"
                                  contain
                                  alt="vuetify"
                                  :width="90"
                                  :height="90"
                                  :src="require('@/assets/image/empty.png')">
                                  <!-- <template v-slot:placeholder>
                                    <v-row
                                      class=" "
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template> -->
                                </v-img>
                                <div class="mt-3 fs-16">
                                  Belum Ada Data
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        
                        <!-- <v-col
                          cols="12"
                          md="6" class="pt-0">

                          <div class="fs-15 label-input">
                          
                            Tanggal Jatuh Tempo
                            <div class="fs-14 font-weight-bold mt-1" v-if="Object.keys(order_json).length > 0">
                              * {{ order_json.customer_term }} hari
                            </div>
                          </div>
            
                          <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider 
                                name="Tanggal Jatuh Tempo" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-model="form.date"
                                  
                                  v-on:keyup.enter="save()"
                                  
                                  filled
                                  solo
                                  rounded
                                  dense
                                  
                                  :color="set_color"
                                  placeholder="Tanggal Jatuh Tempo"
            
                                  :disabled="Object.keys(form).length < 1"
            
                                
            
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  >
                                </v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="form.date"
                              :min="new Date().toISOString().substr(0, 10)"
                              @input="menu2 = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col> -->
                        <!-- <v-col
                          cols="12"
                          md="6" class="pt-0">
                          <ValidationProvider
                            name="Biaya Kirim" 
                            rules="required|min_value:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-15 label-input">
                              Biaya Kirim
                            </div>
      
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Biaya Kirim"
      
                              
                              :error-messages="errors"
                              v-model="form.biaya_kirim"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col> -->
                        <!-- <v-col cols="12">
                          <div 
                            class="fs-15 label-input">
                            Catatan
                          </div>
      
                          <v-textarea
                            v-on:keydown.enter.prevent="save()"
                            
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Catatan"
                            row="3"
      
                            
      
                            v-model="form.note"
                            style="border-radius: 10px;">
                          </v-textarea>
                        </v-col> -->
                      </v-row>

                      <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7;" class="mt-6 mb-5">
                        <v-card-text>
                          <div class="fs-15 input-label font-weight-bold py-2">
                            Detail BPB
                          </div>

                          <div>
                            <div style="overflow: auto; ">
                              <table style="width: 100%;">
                                <tr>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Kode Barang
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Nama Barang
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Quantity Diterima
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Quantity Per Pcs
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Harga Per Unit
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Harga Bruto
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Diskon Promo
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Diskon Strata
                                  </td>
                                  <td style="height: 70px; font-size: 11px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Harga Net. 
                                  </td>
                                </tr>
                                <tr v-for="(item, index) in form.varian_arr" :key="index">
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="">
                                    {{ item.varian_sku }}
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="">
                                    {{ item.varian_name }}
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="">
                                    <span v-if="item.qty_pcs_diterima*1 !== 0">{{ item.qty_pcs_diterima }} Pcs</span>
                                    <span v-else-if="item.qty_lusin_diterima*1 !== 0">{{ item.qty_lusin_diterima }} Lusin</span>
                                    <span v-else-if="item.qty_dus_diterima*1 !== 0">{{ item.qty_dus_diterima }} {{ item.varian_total_in_dus === 1 ? 'Pcs' : 'Dus' }}</span>
                                    <span v-else-if="item.qty_dus_diterima*1 === 0 && item.qty_lusin_diterima*1 === 0 && item.qty_pcs_diterima*1 === 0">{{ item.qty_dus_diterima }} {{ item.varian_total_in_dus === 1 ? 'Pcs' : 'Dus' }}</span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;">
                                    <span v-if="item.qty_pcs_diterima*1 !== 0">-</span>
                                    <span v-else-if="item.qty_lusin_diterima*1 !== 0">12</span>
                                    <span v-else-if="item.qty_dus_diterima*1 !== 0">{{ item.varian_total_in_dus }}</span>
                                    <span v-else-if="item.qty_dus_diterima*1 === 0 && item.qty_lusin_diterima*1 === 0 && item.qty_pcs_diterima*1 === 0">{{ item.varian_total_in_dus }}</span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="text-right">
                                    <!-- Rp {{ item.varian_pricelist_pcs_ppn | number_dec }}  -->
                                    <span v-if="item.detail_qty_pcs !== 0">
                                      Rp. {{ item.varian_pricelist_pcs_ppn | number_dec }}
                                    </span>
                                    <span v-else-if="item.detail_qty_lusin !== 0">
                                      Rp. {{ (item.varian_pricelist_pcs_ppn*12) | number_dec }}
                                    </span>
                                    <span v-else-if="item.detail_qty_dus !== 0">
                                      Rp. {{ (item.varian_pricelist_pcs_ppn*item.detail_total_in_dus) | number_dec }}
                                    </span>
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="text-right">
                                    <span v-if="item.qty_pcs_diterima*1 !== 0">{{ item.detail_price_pcs | number_dec }}</span>
                                    <span v-else-if="item.qty_lusin_diterima*1 !== 0">{{ item.detail_price_lusin | number_dec }}</span>
                                    <span v-else-if="item.qty_dus_diterima*1 !== 0">Rp. {{ (item.detail_price_dus.toFixed(2)) | number_dec }}</span>
                                    <!-- {{ (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }} -->
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="text-center">
                                    {{ (((item.varian_discount*1))) | price }}
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="text-center">
                                    {{ (((item.detail_strata_nominal*1)*(item.qty_dus_diterima))) | price }}
                                  </td>
                                  <td style="font-size: 12px; border: 1px solid #ededed; padding: 10px;" class="text-right">
                                    <!-- {{ (((item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)) - ((((item.varian_discount*1)*(item.detail_qty_dus)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))))) | price }} -->
                                    <span v-if="item.qty_pcs_diterima*1 !== 0">
                                      {{ (((item.detail_price_pcs*1)) - ((((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_pcs_diterima))))) | price }}
                                    </span>
                                    <span v-else-if="item.qty_lusin_diterima*1 !== 0">
                                      {{ (((item.detail_price_lusin*1)) - ((((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_lusin_diterima))))) | price }}
                                    </span>
                                    <span v-else-if="item.qty_dus_diterima*1 !== 0">
                                      Rp. {{ ((((item.detail_price_dus*1)) - ((((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_dus_diterima))))).toFixed(2)) | number_dec }}
                                    </span>
                                    <span v-else-if="item.qty_dus_diterima*1 === 0 && item.qty_lusin_diterima*1 === 0 && item.qty_pcs_diterima*1 === 0">
                                      Rp. {{ ((((item.detail_price_dus*1)) - ((((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_dus_diterima))))).toFixed(2)) | number_dec }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>

                          <v-row>
                            <v-col cols="12" md="12" class="d-flex justify-end pt-0">
                              <div class="fs-13">
                                <table style="width: 100%;">
                                  <tr>
                                    <td class="pa-2 font-weight-bold">
                                      Harga Bruto
                                    </td>
                                    <td style="width: 80px" class="pa-2 text-center">
                                      : 
                                    </td>
                                    <td class="pa-2 text-right">
                                      Rp. {{ ((total_nominal*1).toFixed(2)) | number_dec }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="pa-2 font-weight-bold">
                                      Diskon 
                                    </td>
                                    <td style="width: 80px" class="pa-2 text-center">
                                      :
                                    </td>
                                    <td class="pa-2 text-right">
                                      <!-- {{ order_list.total_discount*1 | price }} -->
                                        {{ form.varian_arr.reduce((acc, item) => acc + (((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_dus_diterima))), 0) | price }}
                                    </td>
                                  </tr>
                                  <!-- <tr>
                                    <td class="pa-2 font-weight-bold">
                                      PPN 11%
                                    </td>
                                    <td style="width: 80px" class="pa-2 text-center">
                                      : 
                                    </td>
                                    <td class="pa-2 text-right">
                                      {{ detail.sales_name }}
                                    </td>
                                  </tr> -->
                                  <tr>
                                    <td class="pa-2 font-weight-bold">
                                      Harga Net
                                    </td>
                                    <td style="width: 80px" class="pa-2 text-center">
                                      :
                                    </td>
                                    <td class="pa-2 text-right">
                                      Rp. {{ (((total_nominal*1 - (form.varian_arr.reduce((acc, item) => acc + (((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_dus_diterima))), 0)))).toFixed(2)) | number_dec }}
                                    </td>
                                  </tr>

                                </table>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-form>
                  </ValidationObserver>



                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pt-0 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                to="/finance/invoice"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: {
          
        },
        category: [
          {
            title: 'Parsial',
            id: 'Parsial'
          },
          {
            title: 'Full',
            id: 'Full'
          }
        ],
        modal: false,
        menu2: false,

        dialog: {
          customer: false,
          fullscreen: false
        },
        bukti: 'gambar',
        gambar_url: '',
        pdf_url: '',
        category: ['Gambar', 'Pdf'],
        pembelian: [],
        product_id: '',
        selected: [],
        headers: [],
        list: [],
        supplier: [],
        form: {
          date: '',
          biaya_kirim: '',
          driver_id: '',
          note: '',
          vehicle_id: '',
          province_name: '',
          city_name: '',
          // order_id: '',
          bpb_arr: [],
          varian_arr: [],
          bpb_id: ''
          // category: '',
          // image_url: '',
          // pdf_url: ''
        },
        total_nominal: 0,
        order_json: {},
        varian_arr: [],
        vehicle: [],
        driver: [],
        order: [],
        headers_data: [],
        supervisor: [],
        branch: [],
        province: [],
        city: [],

        mobilephone: {
          name: '',
          id: ''
        },

        search: '',

        lastIndex: 1,

        upload: {
          pdf_url: null,
          image_url: null
        },

        process: {
          form: false,
          load: false,

          pdf_url: false,

          image_url: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
      uploaddocument: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document.vue')
    },
    watch: {
      'upload.pdf_url': {
        handler: function () {
          if (this.upload.pdf_url) {
            this.process.pdf_url = this.upload.pdf_url.process

            if (!this.process.pdf_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.pdf_url = this.upload.pdf_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.image_url': {
        handler: function () {
          if (this.upload.image_url) {
            this.process.image_url = this.upload.image_url.process

            if (!this.process.image_url) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.gambar_url = this.upload.image_url.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
          return this.headers_data.filter(header => !header.hide)  
        },
    },
    mounted () {
      this.fetchOrder()
    },
    methods: {
      customFilter (item, queryText, itemText) {
        return (
          item.number.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
            -1 ||
          item.customer_name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        );
      },
      async fetchOrder () {
        // this.form.bpb_arr = []
        this.process.load = true

        let params = {
          limit: 100,
          is_delivery: '1',
          is_invoice: '0',
          is_warehouse_confirm: '1',
          search: this.search
          // status: 'persiapan'
          // limit: 1000000,
          // par_id: '1'
        }

        await get(`admin/bpb/data`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.pembelian = res.results.data
            this.order = res.results.data
            
          }
          this.process.load = false
        })
      },
      changeOrder() {
        // this.order_json = []
        // this.varian_arr = []
        this.message.error = ''
        this.order_json = this.order.find(x => x.id === this.form.bpb_id)
        this.fetchDetailOrder(this.form.bpb_id)
        // for (let i = 0; i < this.form.bpb_arr.length; i++) {
        //   this.fetchDetailOrder(this.form.bpb_arr[i])
        // }
      },

      async fetchDetailOrder (id) {
        let params = {
          bpb_id: id
        }

        await get('admin/bpb/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // let data = []
            this.form.varian_arr = []
            // res.results.data.detail.map((item) => {
            //   data.push(item)
            // })
            // this.order_json.res.results.data
            // data.map((item) => {
              // console.log(res.results.data.data)
              this.total_nominal = 0

              res.results.data.data.map((item) => {
                this.form.varian_arr.push({
                  ...item,
                  detail_strata_nominal: 0,
                  detail_strata_id: 0,
                  qty_dus_diterima: item.qty_dus_diterima === '0' ? item.qty_pcs_diterima : item.qty_dus_diterima*1,
                  qty_pcs_diterima: '0'
                })
              })
              // this.form.varian_arr=res.results.data.data
              this.form.varian_arr.map((item, index) => {
              item.detail_price_pcs = ((item.qty_pcs_diterima*1)*(item.varian_pricelist_pcs_ppn*1))
              item.detail_price_lusin = ((item.qty_lusin_diterima*1)*(item.varian_pricelist_pcs_ppn*1)*12)
              item.detail_price_dus = ((item.qty_dus_diterima*1)*(item.varian_pricelist_pcs_ppn*1)*(item.varian_total_in_dus*1))
              console.log(item.qty_dus_diterima*item.varian_pricelist_pcs_ppn*item.varian_total_in_dus)
              console.log(item.varian_discount)
              console.log(item.detail_price_dus*1)
              console.log(item.detail_price_lusin*1)
              console.log(item.detail_price_pcs*1)
            })
            this.form.varian_arr.map((item, index) => {
              this.total_nominal += item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1
              this.fetchCheckStrata(item.orders_store_id, item.varian_id, item.qty_dus_diterima, index)
            })
            // })

            // this.varian_arr.varian_arr = []
            // this.varian_arr.map((items, index) => {
            //   this.varian_arr[index].varian_arr = []
            //   this.varian_arr[index].detail.map((item) => {
            //     this.varian_arr[index].varian_arr.push({
            //       varian_id: item.detail_varian_id,
            //       varian_name: item.detail_varian_name,
            //       varian_sku: item.detail_varian_sku,
            //       qty_pcs_diterima_approve: item.detail_qty_pcs_diterima_approved === undefined ? 0 : item.detail_qty_pcs_diterima_approved*1,
            //       qty_lusin_approve: item.detail_qty_lusin_approved === undefined ? 0 : item.detail_qty_lusin_approved*1,
            //       qty_dus_approve: item.detail_qty_dus_approved === undefined ? 0 : item.detail_qty_dus_approved*1,
            //       qty_pcs_diterima: 0,
            //       qty_lusin: 0,
            //       qty_dus: 0,
                  
            //     })
            //   })
            // })


          }
        })
      },

      async fetchCheckStrata (store_id, varian_id, qty, index) {

        let params = {
          store_id: store_id,
          varian_id: varian_id,
          qty: qty
        }

        await get(`admin/customer_invoice/check_strata`, { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.varian_arr[index].detail_strata_nominal = res.results.data.strata_nominal === undefined ? 0 : res.results.data.strata_nominal
            this.form.varian_arr[index].detail_strata_id = res.results.data.strata_id === undefined ? 0 : res.results.data.strata_id
          }
        })
      },

      async save () {
        this.message.error = ''
        if(this.total_nominal - this.form.varian_arr.reduce((acc, item) => acc + (((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_dus_diterima))), 0) <= 0) {
          this.message.error = 'Total nominal tidak boleh kurang dari atau sama dengan 0'
          return
        }
        this.message.error = ''

        // console.log(dateFormated);
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          var someDate = new Date();
            someDate.setDate(someDate.getDate() + (this.order_json.customer_term*1)); //number  of days to add, e.x. 15 days
            var dateFormated = someDate.toISOString().substr(0,10);
          let form = {
            due_date: dateFormated,
            bpb_id: this.form.bpb_id,
            biaya_kirim: this.form.biaya_kirim,
            item_array: this.form.varian_arr.map((item) => {
              return {
                strata_id: item.detail_strata_id,
                strata_nominal: item.detail_strata_nominal,
                orders_detail_id: item.orders_detail_id

              }
            }),
            sub_total: this.total_nominal,
            total: this.total_nominal - this.form.varian_arr.reduce((acc, item) => acc + (((item.varian_discount*1)) + ((item.detail_strata_nominal*1)*(item.qty_dus_diterima))), 0)
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/customer_invoice/add`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: '/finance/invoice' })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style >
table {
  border-collapse: collapse;
  width: 100%;
}

/* tr {
  border-bottom: 1px solid #ddd;
} */
</style>